module.exports = __webpack_public_path__ + "img/bank1.1b8821d6.jpg";